(function () {

  'use strict';


  function initPhoebeAnimations(root) {

    root = root || document;


    /* =====================================================
       TEXT / CONTENT ELEMENTS
    ====================================================== */

    const revealSelectors = [
      'main h1',
      'main h2',
      'main h3',
      'main .section-heading',
      'main .ph-about-eyebrow',
      'main .ph-about-body',
      'main .cj-step-heading',
      'main .footer__heading'
    ];


    const revealElements =
      root.querySelectorAll(
        revealSelectors.join(',')
      );


    revealElements.forEach(function (element, index) {

      if (
        element.classList.contains('ph-reveal') ||
        element.closest('.header')
      ) {
        return;
      }

      element.classList.add('ph-reveal');

      const delayClass =
        'ph-delay-' + ((index % 4) + 1);

      element.classList.add(delayClass);

    });


    /* =====================================================
       IMAGES
    ====================================================== */

    const images =
      root.querySelectorAll(
        [
          'main section img',
          'main .media img',
          'main .ph-about-story__main-image img',
          'main .ph-about-story__floating-image img',
          'main .ph-about-process__main-image img',
          'main .ph-about-process__small-image img'
        ].join(',')
      );


    images.forEach(function (image) {

      if (
        image.classList.contains('ph-reveal-image')
      ) {
        return;
      }

      /*
       * Hero / above-the-fold image ko animate nahi karte.
       * Page immediately clean load hota hai.
       */

      if (
        image.closest('.hero') ||
        image.closest('.ph-about-hero') ||
        image.closest('.header')
      ) {
        return;
      }

      image.classList.add(
        'ph-reveal-image'
      );

    });


    /* =====================================================
       OBSERVER
    ====================================================== */

    const animatedElements =
      root.querySelectorAll(
        '.ph-reveal, .ph-reveal-image'
      );


    if (
      !('IntersectionObserver' in window)
    ) {

      animatedElements.forEach(function (element) {
        element.classList.add('is-visible');
      });

      return;
    }


    const observer =
      new IntersectionObserver(
        function (entries, currentObserver) {

          entries.forEach(function (entry) {

            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add(
              'is-visible'
            );

            currentObserver.unobserve(
              entry.target
            );

          });

        },
        {
          root: null,
          threshold: 0.12,
          rootMargin: '0px 0px -40px 0px'
        }
      );


    animatedElements.forEach(
      function (element) {

        /*
         * Don't observe something already animated.
         */

        if (
          element.dataset.phAnimated === 'true'
        ) {
          return;
        }

        element.dataset.phAnimated =
          'true';

        observer.observe(element);

      }
    );

  }


  /* =======================================================
     INITIAL LOAD
  ======================================================== */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initPhoebeAnimations(document);
      }
    );

  } else {

    initPhoebeAnimations(document);

  }


  /* =======================================================
     SHOPIFY THEME EDITOR SUPPORT
  ======================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initPhoebeAnimations(
        event.target
      );

    }
  );

})();